import React,{useState} from 'react';
import PanelPromovido from './RPAPanelPromovido';
const RPATablaPromotor = ({datosJS,totalPromov}) => {
    let datos=datosJS;
    //console.log(datosJS);
    const [tabla,setTabla]=  useState("");      
    const [promotor,guardarPromotor] = useState({ nombre:''});
    const [registro,setRegistro]=useState("");
    const[infoPromot,setinfoPromot]=useState("");
    const RenglonNum =(valorId,regis)=>{
       //console.log(valorId);
        setTabla(valorId);
        let info=datos.filter((dat)=>dat.promoPromotorId=== valorId) ;
        //console.log(info[0].PromotNombre);
        localStorage.setItem('NomProm',''+info[0].promoPromotorNom);
        setRegistro(regis);
        setinfoPromot(info[0]);
    }

    function filtro(){        
        let auxCadena=nombre.trim();         
        let info=datos.filter((dat)=>dat.promoPromotorNom.toUpperCase().search(auxCadena.toUpperCase() ) !== -1)         
        return TablaPromo(info);
    }

    function TablaPromo(datos) {
        let numRenglon=0;
        return(
            <div id="tamTabla">
                <table className="table is-sobrepuesto " >
                    <thead >    
                        <tr>
                            <th style={{padding: 0.2 +'rem'}}>Promotores</th>                        
                            <th style={{padding: 0.2 +'rem'}}> Promov.</th>                             
                        </tr> 
                        <tr>
                            <th style={{padding: 0.2 +'rem'}}> </th>                        
                            <th style={{padding: 0.2 +'rem'}}> {totalPromov}</th>                             
                        </tr>                        
                    </thead>  
                    <tbody>          
                        {datos.map((promotor) => {
                            let auxNombre="";
                            auxNombre=promotor.promoPromotorNom;    
                            //console.log(auxNombre);
                            numRenglon++;                          
                        return (                  
                            <tr className={ tabla === promotor.promoPromotorId ? 'is-seleccionado' : '' }  key={numRenglon} onClick={ () => RenglonNum(promotor.promoPromotorId,promotor) }  >   
                                <th className={ tabla === promotor.promoPromotorId ? 'is-seleccionado' : '' } style={{padding: 0.2 +'rem'}}><span className="alinear is-size-7">{auxNombre}  </span></th>                                 
                                <th className={ tabla === promotor.promoPromotorId ? 'is-seleccionado' : '' } style={{padding: 0.2 +'rem'}}><span className="alinear is-size-7">{promotor.promovidos}  </span></th>                                                    
                            </tr>              
                            );
                        })
                        }                                
                    </tbody>
                </table>
            </div>
        );
        }
 
	//extraer el promo
	const {nombre} = promotor;        
    const onChange = e =>
    {         
        let expNopermitida = new RegExp('[0-9._:$!%-({})/*|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');     
        let expCadena = new RegExp('[A-Za-z]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) &&!expMas.test(e.target.value))
            ||e.target.value===' '||e.target.value==='') 
        {
            guardarPromotor({
                ...promotor, //copiamos el nombre
                [e.target.name] : e.target.value  
            })
        }


        
    };

    const datGeneral = datosJS&&registro? (<PanelPromovido promId={tabla} infoPromot={infoPromot} promotor={registro}/>):(null)
    const contenido = promotor? (filtro()):(TablaPromo(datos));
    const llamada= datosJS?(contenido):(<div><h2>No contiene datos</h2></div>)
    return (
    <div className="contenido-tbPromov ">
        <div className="tile is-ancestor is-3">
            <div className="tile is-horizontal is-parent" style={{padding: 0 +'rem'}}>
                <div className=" is-child box">                        
                    <div className="container">
                        <div className="field">            
                            <div className="control">
                                <input
                                    className="input" 
                                    type="promo"
                                    name="nombre"                         
                                    placeholder="Buscar promotor"
                                    value={nombre}
                                    onChange={onChange}/>
                            </div>
                        </div>		            
                        {llamada}
                    </div>
                </div>
                { datGeneral/* datGeneral */}
            </div>            
        </div>
       
    </div>
  );
}
 
export default RPATablaPromotor;